export default __webpack_public_path__ + "static/media/protection.0d68085e.svg";